import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { SsoDisabledActionTooltip } from '../../ory/components/SsoDisabledActionTooltip';
import DataGridActionButton from '../DataGridActionButton';
import DataGridSearchField from '../DataGridSearchField';

const TableControlPanel = ({
  addButtonAction,
  addButtonLabel,
  createButtonAction = null,
  createButtonLabel = '',
  createVisitorButtonAction = null,
  createVisitorButtonLabel = '',
  isGuestAccessFFEnabled = false,
  isUserLoggedAsOrySso,
  onSearchFieldChange,
  searchField = false,
  searchFieldPlaceholder = '',
  searchFieldText = '',
  tabToolbar = false,
}) => (
  <Grid
    container
    spacing={2}
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      pb: 1,
      ...(tabToolbar && { px: 3 }),
    }}
  >
    {searchField && (
      <Grid item>
        <DataGridSearchField
          fulltext={searchFieldText}
          onChangeFilter={onSearchFieldChange}
          placeholder={searchFieldPlaceholder}
          size="small"
        />
      </Grid>
    )}
    {createVisitorButtonAction && isGuestAccessFFEnabled && (
      <Grid item>
        <SsoDisabledActionTooltip isUserLoggedAsOrySso={isUserLoggedAsOrySso}>
          <DataGridActionButton
            onClick={createVisitorButtonAction}
            startIcon={<AddIcon />}
            sx={{ minHeight: '100%' }}
            variant="outlined"
            disabled={isUserLoggedAsOrySso}
          >
            {createVisitorButtonLabel}
          </DataGridActionButton>
        </SsoDisabledActionTooltip>
      </Grid>
    )}
    {createButtonAction && (
      <Grid item>
        <SsoDisabledActionTooltip isUserLoggedAsOrySso={isUserLoggedAsOrySso}>
          <DataGridActionButton
            onClick={createButtonAction}
            startIcon={<AddIcon />}
            sx={{ minHeight: '100%' }}
            variant="outlined"
            disabled={isUserLoggedAsOrySso}
          >
            {createButtonLabel}
          </DataGridActionButton>
        </SsoDisabledActionTooltip>
      </Grid>
    )}
    <Grid item>
      <DataGridActionButton
        onClick={addButtonAction}
        startIcon={<AddIcon />}
        sx={{ minHeight: '100%' }}
        variant={createButtonAction ? 'contained' : 'outlined'}
      >
        {addButtonLabel}
      </DataGridActionButton>
    </Grid>
  </Grid>
);

TableControlPanel.propTypes = {
  addButtonAction: PropTypes.func.isRequired,
  addButtonLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  createButtonAction: PropTypes.func,
  createButtonLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  createVisitorButtonAction: PropTypes.func,
  createVisitorButtonLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  isGuestAccessFFEnabled: PropTypes.bool,
  isUserLoggedAsOrySso: PropTypes.bool,
  onSearchFieldChange: PropTypes.func,
  searchField: PropTypes.bool,
  searchFieldPlaceholder: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  searchFieldText: PropTypes.string,
  tabToolbar: PropTypes.bool,
};

export default TableControlPanel;
